import { Action, ActionReducer, createReducer, on } from '@ngrx/store';
import * as actions from './my-work-permits.actions';
import { initialState, MyWorkPermitsState } from './my-work-permits.state';

const reducer: ActionReducer<MyWorkPermitsState, Action> = createReducer(
  initialState,

  on(
    actions.getMyWorkPermitsSuccess,
    (state, { myWorkPermits }): MyWorkPermitsState => ({
      ...state,
      myWorkPermits,
    })
  ),
  // The foreigner's landing must never wait for a failed request.
  on(
    actions.getMyWorkPermitsError,
    (state): MyWorkPermitsState => ({
      ...state,
      myWorkPermits: state.myWorkPermits ?? [],
    })
  ),

  on(
    actions.getMyWorkPermit,
    (state, { workPermitId }): MyWorkPermitsState => ({
      ...state,
      myWorkPermit: state.myWorkPermit?.id === workPermitId ? state.myWorkPermit : null,
      loadingMyWorkPermit: true,
    })
  ),
  on(
    actions.getMyWorkPermitSuccess,
    (state, { myWorkPermit }): MyWorkPermitsState => ({
      ...state,
      myWorkPermit,
      loadingMyWorkPermit: false,
    })
  ),
  on(
    actions.getMyWorkPermitError,
    (state): MyWorkPermitsState => ({
      ...state,
      myWorkPermit: null,
      loadingMyWorkPermit: false,
    })
  ),

  on(
    actions.removeMyWorkPermitDocumentFile,
    (state, { file }): MyWorkPermitsState => ({
      ...state,
      removingFileIds: [...state.removingFileIds, file.id],
    })
  ),
  on(
    actions.removeMyWorkPermitDocumentFileSuccess,
    actions.removeMyWorkPermitDocumentFileError,
    (state, { userAssetId }): MyWorkPermitsState => ({
      ...state,
      removingFileIds: state.removingFileIds.filter(id => id !== userAssetId),
    })
  )
);

export function myWorkPermitsReducer(state: MyWorkPermitsState | undefined, action: Action): MyWorkPermitsState {
  return reducer(state, action);
}
